__turbopack_context__.v({
  "container": "TEIAUW_container",
  "filename": "TEIAUW_filename",
  "icon": "TEIAUW_icon",
  "row": "TEIAUW_row",
});
